"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WogUserIdentifierType = void 0;
var WogUserIdentifierType;
(function (WogUserIdentifierType) {
    WogUserIdentifierType["HASHED_NRIC"] = "hashed-nric";
    WogUserIdentifierType["WOG_EMAIL"] = "wog-email";
    WogUserIdentifierType["GMAIL"] = "gmail";
    WogUserIdentifierType["UEN"] = "uen";
})(WogUserIdentifierType || (exports.WogUserIdentifierType = WogUserIdentifierType = {}));
//# sourceMappingURL=user-identifier.js.map